<template>
    <div class="w-full flex justify-center h-screen bg-white flex flex-col text-center items-center justify-center align-content-center">
        <img src="@/assets/icons/404.svg" class="mb-16" alt="404"/>
        <p class="text-display-1 text-default-1">Page not found</p>
        <p class="text-body-3 text-interactive-7 font-medium mt-3">The page is missing or the link to the page is incorrect</p>
        <div class="flex flex-row mt-10 cursor-pointer hover:opacity-80" @click="router.push('/')">
            <ArrowLeft :color="color.hex"/>
            <p class="text-body-5 text-primary-1 ml-4">Go to Dashboard</p>
        </div>
    </div>
</template>
<script setup>
import ArrowLeft from "@/components/icons/navigation/ArrowLeft.vue";
import {useTheme} from "@/stores/ThemeStore";
import router from "@/router";

const {color} = useTheme();
</script>